import { Component, Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';
import { DialogService } from '../services/dialog.service';
import { ConfirmationChangePageModel } from '../model/http/commons.model';
import { ChangePageComponent } from '../dialogs/change-page/change-page.component';

@Injectable({
  providedIn: 'root'
})
export class ChangesConfirmationUtilitiesGuard implements CanDeactivate<Component> {
  constructor(private commonService: CommonService, private dialogService: DialogService) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.commonService.getHasChanges() && nextState?.url.includes('/')) {
        return this.openConfirmationDialog();
      }
      return true;
  }

  openConfirmationDialog(): Observable<boolean> {
    const dataObject = new ConfirmationChangePageModel();
    dataObject.title = 'Cambios no guardados en tus precios';
    dataObject.message =
      `Tienes ajustes en tus precios públicos que no han sido guardados.` +
      `Si sales ahora, perderás los cambios realizados.`;
    dataObject.extraQuestion = '¿Deseas continuar?';
    dataObject.closeTrueButton = 'Salir sin guardar';
    dataObject.closeFalseButton = 'Volver a mis precios';
    const dialogRef = this.dialogService.displayDialog(ChangePageComponent, {
      data: dataObject
    });

    return dialogRef.afterClosed();
  }
}
